import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  BusinessPolicyFieldsFragment,
  GetBusinessPoliciesDocument,
  GetBusinessPoliciesQuery,
  GetBusinessPoliciesQueryVariables,
  GetBusinessPolicyDocument,
  GetBusinessPolicyQuery,
  GetBusinessPolicyQueryVariables,
  GetInsuranceCarriersDocument,
  GetInsuranceCarriersQuery,
  GetInsuranceCarriersQueryVariables,
  InsuranceCarrierFieldsFragment
} from '~/api/graphql';

export const getInsuranceCarriers = async () =>
  queryData<
    GetInsuranceCarriersQuery,
    GetInsuranceCarriersQueryVariables,
    InsuranceCarrierFieldsFragment[]
  >(
    client,
    { query: GetInsuranceCarriersDocument, fetchPolicy: 'cache-first' },
    (data) => data?.carriers || []
  );

export const getBusinessPolicies = async () =>
  queryData<
    GetBusinessPoliciesQuery,
    GetBusinessPoliciesQueryVariables,
    BusinessPolicyFieldsFragment[]
  >(client, { query: GetBusinessPoliciesDocument }, (data) => data?.businessPolicies || []);

export const getBusinessPolicy = async (id: string) =>
  queryData<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables, BusinessPolicyFieldsFragment>(
    client,
    { query: GetBusinessPolicyDocument, variables: { id: id } },
    (data) => data?.businessPolicy
  );

export const loadBusinessPolicies: LoaderFunction = () =>
  loadQuery(getBusinessPolicies(), {
    notFoundRedirect: '/policies',
    suppressAuthErrors: true
  });

export const loadInsuranceCarriers: LoaderFunction = () =>
  loadQuery(getInsuranceCarriers(), {
    notFoundRedirect: '/app/signin',
    suppressAuthErrors: true
  });

export const loadBusinessPolicy: LoaderFunction = ({ params }) =>
  loadQuery(getBusinessPolicy(params.id || ''), { notFoundRedirect: '/app/policies' });
